import dark from './dark'
import light from './light'
import  bwmodel from '@/config/bwmodel'
let styles = bwmodel.theme === '1' ? dark : light
export default{
  ...styles
}


// WEBPACK FOOTER //
// ./src/styles/index.js